const home = {
  hero: {
    title: {
      line1: 'Grow Your',
      line2: 'Digital Business',
      line3: 'with AI & Social Media'
    },
    description: 'We help entrepreneurs and business owners scale, automate, and dominate the digital world with digital marketing strategies and AI tools.',
    buttons: {
      start: 'Start Now',
      services: 'View Services'
    },
    miniStats: {
      students: 'Students',
      clients: 'Clients',
      years: 'Years'
    }
  },
  services: {
    badge: 'What We Do',
    titlePrefix: 'Our',
    titleHighlight: 'Services',
    subtitle: 'Complete digital solutions to grow your business online with proven digital marketing strategies.',
    popular: 'Most Popular',
    more: 'Learn more',
    allButton: 'View All Services',
    items: {
      web: {
        title: 'Website Creation + Hosting',
        desc: 'Modern, high-converting websites with mobile optimization, SEO structure, and hosting included.'
      },
      crm: {
        title: 'CRM Creation',
        desc: 'Custom CRM systems to manage leads, clients, workflows, and internal operations.'
      },
      branding: {
        title: 'Branding & Design',
        desc: 'Brand identity with logos, color palettes, visual direction, and marketing materials.'
      },
      socialConsulting: {
        title: 'Social Media Consulting',
        desc: 'Strategic guidance to help your business grow and position effectively on social media.'
      },
      content: {
        title: 'Content Consulting',
        desc: 'Guide to creating strategic and engaging content that connects with your audience and converts.'
      },
      optimization: {
        title: 'Social Media Optimization',
        desc: 'Optimization of social media profiles to improve clarity, branding, and conversion.'
      },
      google: {
        title: 'Google Business Profile',
        desc: 'Setup and optimization of your Google Business Profile to improve local visibility.'
      },
      automation: {
        title: 'AI Automation & Funnels',
        desc: 'Automated systems, funnels, and AI workflows that work 24/7 for you.'
      },
      strategy: {
        title: 'Consulting & Strategy',
        desc: 'Personalized consulting sessions focused on growth, digital strategy, and execution.'
      },
      business: {
        title: 'Business Consulting',
        desc: 'LLC formation, licensing, business structure, and professional network from day one.'
      }
    }
  },
  products: {
    badge: 'Digital Store',
    titlePrefix: 'Products &',
    titleHighlight: 'Offers',
    categories: {
      courses: 'Courses',
      products: 'Products',
      workshops: 'Workshops',
      services: 'Services'
    },
    items: {
      socialMastery: {
        title: 'Social Media Mastery',
        desc: 'Learn to create viral content and grow your audience on Instagram, TikTok, and Facebook from scratch.',
        cta: 'Buy Now',
        badge: 'Best Seller'
      },
      aiAutomation: {
        title: 'AI Business Automation',
        desc: 'Master AI tools to automate your business and multiply your income.',
        cta: 'Buy Now',
        badge: 'New'
      },
      contentCalendar: {
        title: 'Content Calendar Template',
        desc: 'Professional content calendar template to plan 30 days of posts.',
        cta: 'Buy Now'
      },
      brandKit: {
        title: 'Full Brand Kit',
        desc: 'Digital brand kit with Canva templates, color guide, and typographies for your business.',
        cta: 'Buy Now'
      },
      launchBusiness: {
        title: 'Workshop: Launch Your Business',
        desc: '3-hour live workshop to launch your digital business from scratch with strategy.',
        cta: 'Enroll Now',
        badge: 'Live'
      },
      emailMarketing: {
        title: 'Masterclass: Email Marketing',
        desc: 'Learn to build your email list and create campaigns that generate automatic sales.',
        cta: 'Enroll Now'
      },
      consulting1on1: {
        title: '1-on-1 Consulting',
        desc: '60-minute private session to review your digital strategy and create an action plan.',
        cta: 'Book Now',
        badge: 'Premium'
      },
      socialManagement: {
        title: 'Social Media Management',
        desc: 'Complete monthly service for managing your social media with strategy and content.',
        cta: 'Hire Now',
        priceSuffix: '/month'
      }
    }
  },
  academy: {
    badge: 'Online Academy',
    titleMain: 'Smart Business',
    titleHighlight: 'Academy',
    subtitle: 'Learn to build multiple sources of income online. The academy designed for Latino entrepreneurs who want to dominate the digital world.',
    benefits: [
      'Digital marketing and social media courses',
      'AI strategies and business automation',
      'Private entrepreneur community',
      'Live mentorships with Cathy Roldán',
      'Recognized digital certificates'
    ],
    button: 'Explore the Academy',
    visual: {
      module: 'Module 1: Fundamentals',
      topic: 'Digital Marketing for Business',
      completed: 'completed',
      status: 'In progress'
    },
    stats: {
      students: 'Students',
      rating: 'Rating'
    }
  },
  testimonials: {
    badge: 'Testimonials',
    titlePrefix: 'What Our',
    titleHighlight: 'Clients Say',
    subtitle: 'Real stories from entrepreneurs who transformed their businesses with our digital marketing strategies.',
    items: [
      {
        name: 'Maria Gonzalez',
        role: 'Online Boutique Owner',
        location: 'Miami, FL',
        text: 'Thanks to Cathy and her team, my online boutique went from 200 to over 5,000 followers in 3 months. Sales increased by 300%. Incredible!'
      },
      {
        name: 'Carlos Mendoza',
        role: 'Fitness Coach',
        location: 'Los Angeles, CA',
        text: 'The AI automation they implemented in my business saves me 20 hours a week. Now I can focus on what I love: training my clients.'
      },
      {
        name: 'Ana Rodriguez',
        role: 'Business Consultant',
        location: 'New York, NY',
        text: 'The Social Media Mastery course completely changed my perspective. In 6 weeks I launched my personal brand and got my first 10 clients.'
      },
      {
        name: 'Roberto Silva',
        role: 'Restaurant Owner',
        location: 'Houston, TX',
        text: 'Smart Business Digital Solutions transformed my restaurant\'s online presence. Now we have full reservations every weekend thanks to social media.'
      },
      {
        name: 'Valentina Torres',
        role: 'Content Creator',
        location: 'Chicago, IL',
        text: 'The Smart Business Academy gave me all the tools to monetize my content. In 4 months I\'m already generating passive income with my digital courses.'
      }
    ]
  },
  cta: {
    badge: 'Ready to Grow?',
    titlePrefix: 'Start Your Digital',
    titleHighlight: 'Business Today',
    subtitle: 'Join hundreds of Latino entrepreneurs who are already scaling their businesses with digital marketing, AI, and automated systems.',
    buttons: {
      academy: 'Join the Academy',
      consult: 'Book a Consultation',
      services: 'View Services'
    },
    indicators: [
      'Satisfaction Guarantee',
      'Personalized Support',
      'Global Community'
    ]
  },
  aboutPreview: {
    badge: 'Get to Know Your Mentor',
    subtitle: 'Entrepreneur · Digital Mentor · Educator',
    desc1: 'With over 8 years of experience in digital marketing, Cathy has helped hundreds of Latino entrepreneurs build profitable online businesses. Her mission is to empower the Latino community with the tools and knowledge of the digital world.',
    desc2: 'Specialist in social media, AI automation, and digital business strategies. Founder of Smart Business Academy, the educational platform for Hispanic entrepreneurs.',
    tags: ['Digital Marketing', 'AI & Automation', 'Social Media', 'Online Education'],
    button: 'Learn More',
    floating: {
      title: 'Founder & CEO',
      subtitle: 'Smart Business'
    }
  },
  trust: {
    badge: 'Global Trust',
    title: 'Trusted by entrepreneurs worldwide',
    stats: {
      students: 'Active Students',
      clients: 'Clients Served',
      years: 'Years of Experience',
      satisfaction: 'Satisfaction'
    },
    platforms: 'Platforms we master'
  }
};

export default home;
